import { createContext } from 'react'
import { IFeatureFlagsClient } from './interfaces'
import { NoopFeatureFlagsClient } from './NoopFeatureFlagsClient'

export const FeatureFlagsContext = createContext<IFeatureFlagsClient>(new NoopFeatureFlagsClient())
